import useIntersectionObserver from '@react-hook/intersection-observer'
import { useRef, useCallback, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import 'intersection-observer'
import LazyLoad from "vanilla-lazyload";
import lazyloadConfig from "./config/lazyload";
// Only initialize it one time for the entire application
if (!document.lazyLoadInstance) {
    document.lazyLoadInstance = new LazyLoad(lazyloadConfig);
  }

export default ({ src }) => {
  const [inViewRef, inView] = useInView({
    threshold: 1,
  })
  const videoRef = useRef()

  const setRefs = useCallback(
    (node) => {
      // Ref's from useRef needs to have the node assigned to `current`
      videoRef.current = node
      // Callback refs, like the one from `useInView`, is a function that takes the node as an argument
      inViewRef(node)

      if (node) {
        node.addEventListener('click', function () {
          if (this.paused) {
            this.play()
          } else {
            this.pause()
          }
        })
      }
    },
    [inViewRef]
  )

  useEffect(() => {
    if (!videoRef || !videoRef.current) {
      return
    }

    if (inView) {
      videoRef.current.play()
    } else {
      videoRef.current.pause()
    }
  }, [inView])

  return (
    <>
      {/* <div style={{ paddingBottom: ratio * 100 + '%' }}/> */}
      <video width="100%"
      className={"lazy"}
        loop="loop"
        autoplay=""
        muted
        playsInline
        webkit-playsinline ref={setRefs}>
        <source src={src} type="video/mp4" />
      </video>
    </>
  )
}
